import { render, staticRenderFns } from "./AddCampaignForm3.vue?vue&type=template&id=5394c72e&"
import script from "./AddCampaignForm3.vue?vue&type=script&lang=js&"
export * from "./AddCampaignForm3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports